(function () {
  if (window.__gpoOrphanCleanupPatched) return;
  window.__gpoOrphanCleanupPatched = true;

  var originalFetch = window.fetch;

  function refreshMiniCart() {
    fetch(window.location.pathname + '?section_id=form-mini-cart', { cache: 'no-store' })
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var fresh = parsed.querySelector('#form-mini-cart');
        var current = document.getElementById('form-mini-cart');
        if (fresh && current) current.innerHTML = fresh.innerHTML;
        if (window.BlsLazyloadImg && typeof window.BlsLazyloadImg.init === 'function') {
          window.BlsLazyloadImg.init();
        }
      })
      .catch(function () {});

    fetch('/cart.js', { cache: 'no-store' })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        document.querySelectorAll('.cart-count').forEach(function (el) {
          el.innerHTML = cart.item_count;
        });
      })
      .catch(function () {});
  }

  function removeOrphanAddons(cart) {
    if (!cart || !cart.items) return;
    var parents = {};
    cart.items.forEach(function (item) {
      var group = item.properties && item.properties._gpo_product_group;
      if (group) parents[group] = true;
    });
    var updates = {};
    var found = false;
    cart.items.forEach(function (item) {
      var parentGroup = item.properties && item.properties._gpo_parent_product_group;
      if (parentGroup && !parents[parentGroup]) {
        updates[item.key] = 0;
        found = true;
      }
    });
    if (!found) return;
    originalFetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(function (res) {
      if (res.ok) refreshMiniCart();
    }).catch(function () {});
  }

  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var promise = originalFetch.apply(this, arguments);
    if (/\/cart\/change(\.js)?(\?|$)/.test(url) && !/^\/cart\/?$/.test(window.location.pathname)) {
      promise.then(function (response) {
        if (response && response.ok) {
          response.clone().json().then(removeOrphanAddons).catch(function () {});
        }
      }).catch(function () {});
    }
    return promise;
  };
})();
